import { FunctionComponent } from "react";

export const DieBayerischeLogo: FunctionComponent = () => {
  return (
    <img
      src="/images/brand/bayerische.svg"
      className={"w-32 md:w-[161px] max-h-[40px] object-contain"}
      alt="Die Bayerische"
    />
  );
};
